import script from "./WorkflowAssistantPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowAssistantPanel.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowAssistantPanel.vue?vue&type=style&index=0&id=4873f3a5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4873f3a5"]])

export default __exports__